import Modal from 'react-bootstrap/Modal';
import { useTicketCatalog } from '../core/_hooks';
import { type TicketComposerStep, type TicketOpenedHandler, type TicketPrefill } from '../core/_models';
import TicketComposerForm from './TicketComposerForm';

type Props = {
  show: boolean;
  initialStep: TicketComposerStep;
  prefill?: TicketPrefill;
  origin: string;
  onTicketOpened: TicketOpenedHandler;
  onClose: () => void;
};

const TicketComposerModal = ({ show, initialStep, prefill, origin, onTicketOpened, onClose }: Props) => {
  const catalogQuery = useTicketCatalog();
  const catalog = catalogQuery.data;

  return (
    <Modal scrollable aria-labelledby="ticket-composer-title" show={show} size="lg" onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title id="ticket-composer-title">Abrir chamado</Modal.Title>
      </Modal.Header>
      {catalog ? (
        <TicketComposerForm
          catalog={catalog}
          initialStep={initialStep}
          origin={origin}
          prefill={prefill}
          onClose={onClose}
          onTicketOpened={onTicketOpened}
        />
      ) : (
        <Modal.Body className="text-gray-600 fs-6">Carregando…</Modal.Body>
      )}
    </Modal>
  );
};

export default TicketComposerModal;
